import { useSelector } from "react-redux";
import { styled } from '@mui/material/styles';
import { Button } from "..";
import { useHistory } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import successBadge from "../../assets/images/success-badge.svg";

const ButtonContainer = styled('div')(({ theme: { breakpoints } }) => `
  display: flex;
  justify-content: space-evenly;
  width: 40%;
  margin: 50px auto 40% auto;
  ${[breakpoints.down('sm')]} {
    width: 60%;
    margin-bottom: 230px;
  }
`);

export const ResetSuccess = () => {
  const history = useHistory();
  const locale = useSelector((state) => state.globalStates.locale);

  const staticContent = {
    headline: 'Password reset successful',
    icon: successBadge,
    message: 'Your password has been reset successfully. Click below to return home and sign in with your updated credentials.',
    signInButtonLabel: 'Sign In'
  }

  const signInHandler = () => {
    history.push(`/${locale}`);
  }

  return (
    <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
      <Box component={'img'} margin={{xs:'50px auto 20px auto',sm:'20px auto'}} display='flex' id="resetSucessImg" data-testid="resetSucessImg" src={staticContent.icon} width="90px" height="90px"></Box>
      <Typography variant={'h1'} textAlign='center' color='primary.main' id="headline" data-testid="headline">{staticContent.headline}</Typography>
      <Typography variant={'p1'} textAlign='center' mt='20px' id="resetSuccessText" data-testid="resetSuccessText">{staticContent.message}</Typography>
      <ButtonContainer>
        <Button
          data-testid="resetSuccessButton"
          id="resetSuccessButton"
          buttonType="primary"
          onClick={signInHandler}
        >{staticContent.signInButtonLabel}
        </Button>
      </ButtonContainer>
    </Box>
  )
};